export const ERROR_DUPLICATE = '重複しています'
